import type { Ability } from '@core/abilities-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../roles.types';

const { actions, namespace, selectors, reducer } = createSingleEntityStore<Ability[] | null>()(
  EntityStoreKey.ability,
);

export {
  actions as AbilityActions,
  selectors as AbilitySelectors,
  reducer as AbilityReducer,
  namespace as AbilityNamespace,
};
